/* eslint-disable multiline-ternary */
import React from "react";
import {
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { questionTypeSpecs } from "./question-type-specs";

const FormBuilderQuestionTypesPanel: React.FC = () => (
  <Table size="small" sx={{ mb: 2 }}>
    <TableHead>
      <TableRow>
        <TableCell>Type</TableCell>
        <TableCell>Required Data Fields</TableCell>
        <TableCell>Supports</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {Object.entries(questionTypeSpecs).map(([type, spec]) => (
        <TableRow key={type}>
          <TableCell>
            <Stack direction="column" spacing={0.5}>
              <Typography variant="body2" fontWeight={700}>{type}</Typography>
              <Typography variant="caption">{spec.description}</Typography>
            </Stack>
          </TableCell>
          <TableCell>
            {spec.requiredDataFields.length > 0
              ? spec.requiredDataFields.join(", ")
              : "none"}
          </TableCell>
          <TableCell>
            <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
              {spec.supportsConditionals && <Chip size="small" label="conditionals" />}
              {spec.supportsChildren && <Chip size="small" label="children" />}
              {spec.supportsArrayChildren && <Chip size="small" label="array children" />}
            </Stack>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  </Table>
);

export default FormBuilderQuestionTypesPanel;
